import React from "react";
import ContactList from "./ContactList";

const GettingInvolvedBody = ({ data }) => {
	const {
		gettingInvolvedBody,
		contactHeading,
		staffContactHeading,
		staffContact,
		contactLinks,
	} = data;

	return (
		<>
			<h1 className="sr-only">Getting Involved</h1>
			{gettingInvolvedBody}
			{contactHeading}
			<ul className="d-lg-flex flex-row justify-content-center list-unstyled">
				{contactLinks.map(({ id, url, displayText }) => (
					<li key={id} className="card p-3 m-2 h-100 text-center">
						<a href={url}>{displayText}</a>
					</li>
				))}
			</ul>
			<div className="card mt-5">
				<div className="card-header">
					<div className="h4 text-center card-title">
						{staffContactHeading}
					</div>
				</div>
				<div className="card-body px-sm-3 px-lg-3 bg-light rounded-bottom">
					<ContactList staffContact={staffContact} />
				</div>
			</div>
		</>
	);
};

export default GettingInvolvedBody;
